import type { GanttPrintChromeViewModel } from "./types-gantt-print-chrome";
import styles from "./gantt-print-chrome.module.scss";

const logoAsset = new URL("../../../../../assets/print/logo-pdf.png", import.meta.url).href;

export function GanttPrintChromeView({
  title,
  generatedLabel,
  notaSimulacao,
  chips,
  legend,
  mostraMeta,
}: GanttPrintChromeViewModel) {
  return (
    <>
      <header className={styles.banner} data-testid="gantt-print-banner">
        <img className={styles.logo} src={logoAsset} alt="OceanPact" />
        <div className={styles.headText}>
          <h1 className={styles.title}>HUB DE OBRAS – {title}</h1>
          <p className={styles.generated}>{generatedLabel}</p>
          {notaSimulacao ? (
            <p className={styles.simulationNote} data-testid="gantt-print-simulation">
              {notaSimulacao}
            </p>
          ) : null}
        </div>
      </header>
      {mostraMeta ? (
        <section className={styles.meta} data-testid="gantt-print-meta">
          <div className={styles.summary}>
            {chips.length > 0 ? (
              <>
                <p className={styles.summaryTitle}>Resumo de filtros</p>
                <ul className={styles.chips} data-testid="gantt-print-filters">
                  {chips.map(({ line, label, value }) => (
                    <li key={line} className={styles.chip}>
                      {label ? <span className={styles.chipLabel}>{label}: </span> : null}
                      <span className={styles.chipValue}>{value}</span>
                    </li>
                  ))}
                </ul>
              </>
            ) : null}
          </div>
          {legend ? (
            <div className={styles.legend} data-testid="gantt-print-legend">
              {legend}
            </div>
          ) : null}
        </section>
      ) : null}
    </>
  );
}
